import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Trophy, Shield } from 'lucide-react';
import { getMatchResult, resolveBadgeUrl, getVenueAbbrev } from './utils';

export const RecentResultsWidget = ({ stats, user, opponentBadgeMap = {} }) => {
  const showOpponentBadges = user?.show_opponent_badges !== false;

  return (
    <div className="h-full" data-testid="recent-results">
      <div className="flex flex-row items-center justify-between pb-4">
        <h3 className="text-xl font-semibold font-title">Recent Results</h3>
        <Link to="/matches">
          <Button variant="ghost" size="sm" style={{ color: user?.menu_color || '#059669' }} className="hover:opacity-80">
            View All
          </Button>
        </Link>
      </div>
      <div>
        {stats?.recent_results?.length > 0 ? (
          <div className="flex flex-col gap-3">
            {stats.recent_results.slice(0, 3).map((match) => {
              const result = getMatchResult(match);
              const venueAbbrev = getVenueAbbrev(match.venue);
              const opponentBadge = resolveBadgeUrl(opponentBadgeMap[(match.opponent || '').toLowerCase().trim()]);
              const finalScoreLabel = match.is_cup && match.our_score_pens != null && match.opponent_score_pens != null
                ? `PEN (${match.our_score_pens}-${match.opponent_score_pens})`
                : match.is_cup && match.our_score_et != null && match.opponent_score_et != null
                ? 'AET'
                : 'FT';
              return (
                <div
                  key={match.id}
                  className="flex items-center gap-3 p-3 bg-white rounded-xl"
                  style={{ border: '1px solid #e5e2dc' }}
                  data-testid={`recent-result-${match.id}`}
                >
                  {showOpponentBadges && (
                    opponentBadge ? (
                      <img
                        src={opponentBadge}
                        alt={`${match.opponent} badge`}
                        className="w-10 h-10 object-contain shrink-0"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center shrink-0">
                        <Shield className="w-5 h-5 text-gray-300" strokeWidth={1.5} />
                      </div>
                    )
                  )}
                  <div className="flex-1 min-w-0 overflow-hidden">
                    <p className="font-bold text-gray-900 truncate leading-tight">{match.opponent}</p>
                    <p className="text-gray-500 truncate mt-0.5" style={{ fontSize: '0.7rem' }}>
                      {match.competition ? `${match.competition} (${venueAbbrev})` : `(${venueAbbrev})`}
                    </p>
                  </div>
                  <div className="text-right shrink-0">
                    <p className="text-xl font-bold text-gray-900 whitespace-nowrap tracking-tight">
                      {match.is_cup && match.our_score_et != null && match.opponent_score_et != null
                        ? `${match.our_score_et} - ${match.opponent_score_et}`
                        : `${match.our_score} - ${match.opponent_score}`}
                    </p>
                    <div className="flex items-center justify-end gap-1.5 mt-0.5">
                      <span className="text-xs text-gray-400">{finalScoreLabel}</span>
                      <span
                        className={`inline-flex items-center justify-center h-[22px] font-bold ${result.color}`}
                        style={{ fontSize: '8px', minWidth: '18px', paddingLeft: '0.275rem', paddingRight: '0.275rem', borderRadius: 'calc(var(--radius) - 6px)' }}
                      >
                        {result.label}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-400">
            <Trophy className="w-10 h-10 mx-auto mb-2 opacity-50" strokeWidth={1.5} />
            <p>No results yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentResultsWidget;
